import { render, staticRenderFns } from "./search.vue?vue&type=template&id=004cd4b2&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=004cd4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004cd4b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/app/components/ui/input/index.js').default,IconSearch: require('/app/components/icons/IconSearch.vue').default,IconCloseAccent: require('/app/components/icons/IconCloseAccent.vue').default})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
